import {gsap} from 'gsap'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import {ScrollTrigger} from 'gsap/ScrollTrigger'


gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);
let smoothScroll

let mainHeader = $('.navigation');
let newsFilterBlock = $('.js--news-filter-block');
let newsListBlock = $('.news-block');
let servicesFilterBlock = $('.js--services-filter-block');
let servicesListBlock = $('main');
let dragProxyBlock = $('.drag-proxy');

let currentTop = 0,
  previousTop = 0,
  scrollDelta = 10,
  scrollOffset = 150;


let smoothScrollParams = {
  //normalizeScroll: true,
  smooth: 1.5,   // seconds it takes to "catch up" to native scroll position
  smoothTouch: 0.5, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  effects: false, // look for data-speed and data-lag attributes on elements and animate accordingly
  onUpdate: (scroll) => {
    if (!scroll.scrollTrigger) return false

    currentTop = scroll.scrollTop();


    let newsFilter = $('.js--news-open-mobile-filter');
    if(newsFilter.length){
      autoHideHeader(scroll.scrollTop(), newsFilter);
      if (newsFilterBlock) {
        let newsFilterTop = newsFilterBlock.length ? newsFilterBlock.offset().top + newsFilterBlock.height() : '';
        let newsListOffset = newsListBlock.length ? newsListBlock.offset().top + newsListBlock.height() : '';
        if (scroll.scrollTop() + 50 >= newsFilterTop && newsListOffset > scroll.scrollTop()) {
          newsFilter.addClass('displayed');
        } else {
          newsFilter.removeClass('displayed');
        }
      }
      if (dragProxyBlock.length > 0) {
        gsap.to(dragProxyBlock, {
          x: scroll.scrollTop() * -1,
          y: 0
        });
      }
    }

    let servicesFilter = $('.js--services-open-mobile-filter');
    if(servicesFilter.length) {
      autoHideHeader(scroll.scrollTop(), servicesFilter);
      if (servicesFilterBlock) {
        let servicesFilterTop = servicesFilterBlock.length ? servicesFilterBlock.offset().top + servicesFilterBlock.height() : '';
        let servicesListOffset = servicesListBlock.length ? servicesListBlock.offset().top + servicesListBlock.height() : '';
        if (scroll.scrollTop() + 50 >= servicesFilterTop && servicesListOffset > scroll.scrollTop()) {
          servicesFilter.addClass('displayed');
        } else {
          servicesFilter.removeClass('displayed');
        }
      }
      if (dragProxyBlock.length > 0) {
        gsap.to(dragProxyBlock, {
          x: scroll.scrollTop() * -1,
          y: 0
        });
      }
    }
  }
}

function autoHideHeader(scrollNow, classes) {
  checkSimpleNavigation(currentTop, scrollNow, classes);
  previousTop = currentTop;
}

function checkSimpleNavigation(currentTop, scrollNow, classes) {
  // let newsFilter = $('.js--news-open-mobile-filter');
  if (previousTop - currentTop > scrollDelta) {
    mainHeader.removeClass('is-hidden');
    classes && classes.removeClass('is-hidden');
  } else if (currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
    mainHeader.addClass('is-hidden');
    classes && classes.addClass('is-hidden');
  }
  const scrolledClass = (scrollNow === 0 ? '' : 'scrolled');
  mainHeader.toggleClass('scrolled', scrolledClass !== '');
}

if (typeof ScrollSmoother === 'function') {
  smoothScroll = ScrollSmoother.create(smoothScrollParams);

}

export function scrollToId(element) {
  smoothScroll.scrollTo(element, true)
}

export function getSmoothScroll() {
  return smoothScroll
}

export function smoothScrollPause() {
  smoothScroll.paused(true)
}

export function smoothScrollPlay() {
  smoothScroll.paused(false)
}

export function updateSmoothScroll() {
  ScrollTrigger.refresh()
}

export function smoothScrollKill() {
  smoothScroll.kill()
}

export function smoothScrollCreate() {
  smoothScroll = ScrollSmoother.create(smoothScrollParams);
}
